import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Mail, Phone, MessageCircle, MapPin } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Header */}
      <div style={{ background: '#0A0A0A' }} className="py-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-white text-4xl font-black mb-3">Contactez-nous</h1>
          <p className="text-gray-400 text-lg">Notre équipe est là pour vous aider</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          
          {/* Email */}
          <a 
            href="mailto:contact@jjcars.ga"
            className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100 hover:border-yellow-400 transition group"
          >
            <div style={{ background: '#F5A62320' }} className="w-12 h-12 rounded-xl flex items-center justify-center mb-4">
              <Mail size={24} style={{ color: '#F5A623' }} />
            </div>
            <h3 className="font-black text-gray-900 mb-2">Email</h3>
            <p className="text-gray-600 text-sm mb-3">Envoyez-nous un message</p>
            <p style={{ color: '#F5A623' }} className="font-bold text-sm group-hover:underline">
              contact@jjcars.ga
            </p>
          </a>

          {/* WhatsApp */}
          <a 
            href="https://wa.me/24177770070"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100 hover:border-yellow-400 transition group"
          >
            <div style={{ background: '#F5A62320' }} className="w-12 h-12 rounded-xl flex items-center justify-center mb-4">
              <MessageCircle size={24} style={{ color: '#F5A623' }} />
            </div>
            <h3 className="font-black text-gray-900 mb-2">WhatsApp</h3>
            <p className="text-gray-600 text-sm mb-3">Chat en direct</p>
            <p style={{ color: '#F5A623' }} className="font-bold text-sm group-hover:underline">
              +241 77 77 00 70
            </p>
          </a>

          {/* Téléphone */}
          <a 
            href="tel:+24177770070"
            className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100 hover:border-yellow-400 transition group"
          >
            <div style={{ background: '#F5A62320' }} className="w-12 h-12 rounded-xl flex items-center justify-center mb-4">
              <Phone size={24} style={{ color: '#F5A623' }} />
            </div>
            <h3 className="font-black text-gray-900 mb-2">Téléphone</h3>
            <p className="text-gray-600 text-sm mb-3">Appelez-nous</p>
            <p style={{ color: '#F5A623' }} className="font-bold text-sm group-hover:underline">
              +241 77 77 00 70
            </p>
          </a>

          {/* Localisation */}
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div style={{ background: '#F5A62320' }} className="w-12 h-12 rounded-xl flex items-center justify-center mb-4">
              <MapPin size={24} style={{ color: '#F5A623' }} />
            </div>
            <h3 className="font-black text-gray-900 mb-2">Adresse</h3>
            <p className="text-gray-600 text-sm mb-3">Notre bureau</p>
            <p className="text-gray-700 font-semibold text-sm">
              Libreville, Gabon
            </p>
          </div>

        </div>

        {/* Infos supplémentaires */}
        <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
          <h2 className="font-black text-lg mb-4 text-gray-900 flex items-center gap-2">
            <span style={{ color: '#F5A623' }}>|</span> Questions fréquentes
          </h2>
          <div className="space-y-4 text-sm text-gray-600">
            <div>
              <p className="font-bold text-gray-900 mb-1">🔐 Mot de passe oublié ?</p>
              <p>Contactez-nous sur WhatsApp ou par email avec votre numéro de téléphone ou email d'inscription.</p>
            </div>
            <div>
              <p className="font-bold text-gray-900 mb-1">📱 Support technique ?</p>
              <p>Pour tout problème technique, envoyez-nous un message WhatsApp avec une capture d'écran.</p>
            </div>
            <div>
              <p className="font-bold text-gray-900 mb-1">⏱ Horaires de support</p>
              <p>Lundi - Samedi : 8h00 - 18h00 (GMT+1)</p>
            </div>
          </div>
        </div>

        {/* Retour */}
        <div className="text-center mt-8">
          <Link 
            to="/"
            style={{ borderColor: '#F5A623', color: '#F5A623' }}
            className="inline-block border-2 px-8 py-3 rounded-2xl font-bold hover:bg-yellow-50 transition"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contact;
